export default Object.freeze({
    PENDING: 'PENDING',
    DECLINED: 'DECLINED',
    APPROVED: 'APPROVED',
    MEMBERSHIP_REVOKED: 'MEMBERSHIP_REVOKED',
})
